import { createFileRoute } from "@tanstack/react-router"

import { AssetTypeSettingsDetailView } from "../../../../../../../../views/AssetTypeSettingsDetailView/AssetTypeSettingsDetailView"
import { assetTypeSettingsDetailViewStaticData } from "../../../../../../../../views/AssetTypeSettingsDetailView/constants"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/")({
	component: AssetTypeSettingsDetailView,
	staticData: assetTypeSettingsDetailViewStaticData,
})
